import * as lessonsApi from "@/api/lessonsApi.js"

import * as sentryReporter from "@/services/sentryReporter.js"

import i18n from "@/plugins/i18n"

import { useCoursesStore } from "@/store/courses.js"

export const lessonStates = {
  COMPLETED: "completed"
}

export class Lesson {
  constructor({ id, name, content, excerpt, image, user_state }) {
    this.name = name
    this.id = id
    this.excerpt = excerpt
    this.content = content
    this.thumbnailImageUrl = image?.versions?.square_56?.base_url
    this.completed = user_state === lessonStates.COMPLETED
    this.updatingState = false
  }

  async setCompleted(completed) {
    try {
      this.updatingState = true
      const coursesStore = useCoursesStore()

      const endpoint = completed ? lessonsApi.markAsCompleted : lessonsApi.markAsUncompleted
      const currentCourse = coursesStore.course

      const { course } = await endpoint({ lessonId: this.id, courseId: currentCourse.id })
      currentCourse.updateCompletedState({ userEnrollment: course.user_enrollment, afterLessonCompletion: completed, fromLesson: true })

      this.completed = completed
    } catch (err) {
      sentryReporter.reportError(err, i18n.global.t("common.somethingWrong"))
    } finally {
      this.updatingState = false
    }
  }
}
